var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('oil-form',{attrs:{"title":_vm.title,"keys":_vm.keys,"items":_vm.product,"createForm":!_vm.id,"success-message":_vm.message,"formCallback":_vm.formCallBack}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }